import Swal from "sweetalert2";

export default {
  data() {
    return {
      inactivityTimeout: null,
      inactivityLimit: 1800000, // 30 minutos expresados en milisegundos
      //inactivityLimit: 5000, // 1 minuto expresado en milisegundos
    };
  },
  mounted() {
    this.setupInactivityTimer();
  },
  beforeDestroy() {
    this.clearInactivityTimer();
  },
  methods: {
    setupInactivityTimer() {
      this.resetInactivityTimer();
      // Agregar listeners para varios eventos que resetean el temporizador
      document.addEventListener("mousemove", this.resetInactivityTimer);
      document.addEventListener("keydown", this.resetInactivityTimer);
      document.addEventListener("click", this.resetInactivityTimer);
      document.addEventListener("scroll", this.resetInactivityTimer);
    },
    resetInactivityTimer() {
      clearTimeout(this.inactivityTimeout);
      this.inactivityTimeout = setTimeout(() => {
        this.handleInactivity();
      }, this.inactivityLimit);
    },
    clearInactivityTimer() {
      clearTimeout(this.inactivityTimeout);
      document.removeEventListener("mousemove", this.resetInactivityTimer);
      document.removeEventListener("keydown", this.resetInactivityTimer);
      document.removeEventListener("click", this.resetInactivityTimer);
      document.removeEventListener("scroll", this.resetInactivityTimer);
    },
    handleInactivity() {
      // Limpiar la sesión
      window.sessionStorage.removeItem("token");
      window.sessionStorage.removeItem("rol");
      window.sessionStorage.removeItem("usuario");

      // Mostrar la alerta estilizada con SweetAlert2 que no se cierra automáticamente
      Swal.fire({
        title: "Inactividad detectada",
        text: "Se ha detectado inactividad. Serás redirigido a la página de inicio de sesión.",
        icon: "warning",
        showConfirmButton: true,
        confirmButtonText: "Aceptar",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(() => {
        this.$router.push("/Login");
      });
    },
  },
};
